/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

import React, { useRef } from "react";
import { useLoader, useFrame } from "react-three-fiber";
import { a } from "react-spring/three";
import { softShadows } from "drei";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";

softShadows();

export default function Model(props) {
  const group = useRef();
  const { nodes, materials } = useLoader(GLTFLoader, "/litterbox.glb");
  useFrame(() => (group.current.rotation.y = group.current.rotation.y += 0.01));

  return (
    <a.group ref={group} {...props} dispose={null} rotation-x={0.7}>
      <mesh
        material={materials.Litter_Box}
        geometry={nodes.LitterBox_Litter_Box_plastic_bottom.geometry}
      />
      <mesh
        material={materials.Litter_Box}
        geometry={nodes.LitterBox_Litter_Box_plastic_top.geometry}
      />
      <mesh
        material={materials.Litter_Box}
        geometry={nodes.LitterBox_Litter_Box_litter.geometry}
      />
    </a.group>
  );
}
